import { InputText as EpicInputText } from "@constellation-academy/epic-ui";

export const InputText = EpicInputText;
